import React, { useState } from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';
import Portfolio from '../../Portfolio';

export default function GallerySection({ sectionTitle, sectionTitleUp, data }) {
  const [activeLocation, setActiveLocation] = useState('harriman');

  const activeGallery = data?.[activeLocation] || [];

  return (
    <div className="container">
      <div className="cs_gallery_location_tabs">
        <SectionHeading title={sectionTitle} titleUp={sectionTitleUp} />

        <div className="cs_gallery_tab_buttons">
          <button
            type="button"
            className={`cs_btn cs_style_1${activeLocation === 'harriman' ? ' active' : ''}`}
            onClick={() => setActiveLocation('harriman')}
          >
            <span>Harriman Center</span>
          </button>

          <button
            type="button"
            className={`cs_btn cs_style_1${activeLocation === 'newburgh' ? ' active' : ''}`}
            onClick={() => setActiveLocation('newburgh')}
          >
            <span>Newburgh Center</span>
          </button>
        </div>

        <Spacing md="52" xl="52" lg="25" />
      </div>

      <div className="cs_gallery_grid_1">
        {activeGallery.map((item, index) => (
          <div className="cs_grid_item" key={`${activeLocation}-${index}`}>
            <Portfolio {...item} />
          </div>
        ))}
      </div>
    </div>
  );
}